import apiClient from "../../../../../../services/apiClient";

const getFullYear = (d2, period) => {
    const d1 = [period,"10","01"].join('-') + 'T00:00:00';
    const month = new Date(d2).getMonth() > new Date(d1).getMonth() ? new Date(d1).getMonth() - new Date(d2).getMonth() : new Date(d1).getMonth() + (12 - new Date(d2).getMonth());
    const year = new Date(d2).getMonth() > new Date(d1).getMonth() ? new Date(d1).getFullYear() - new Date(d2).getFullYear() : new Date(d1).getFullYear() - new Date(d2).getFullYear() -1;
    return year + (month-1)/12;
};

const zdoRequestsApi = {
  async getRequestsToKindergarten(kgid, period = 'all', minAge = null) {

    let linkPost = '';

    if(period && period !== 'all') {
        linkPost = `requests/queue_to_kindergarten?kgid=${kgid}`;
        
        if (period && period !== 'all') {
          linkPost += `&period=${period}`;
        }
        
        if (minAge) {
          linkPost += `&min_age=${minAge}`;
        }

            const data = await apiClient.get(linkPost);
    
            return {
              requests: data.data?.cursor || [],
              myRequests: data.data?.my_requests || [] // Добавляем массив ID заявок пользователя
            };
    } else {
      //linkPost = `requests/main_info?with_selected_kindergarten=${kgid}&without_statuses=child-in-kindergarten`;

      linkPost = `requests/queue_to_kindergarten?kgid=${kgid}&period=2025`;

        if (minAge) {
          linkPost += `&min_age=${minAge}`;
        }


      const data = await apiClient.get(linkPost);
    
      return {
        requests: data.data?.cursor || [],
        myRequests: data.data?.my_requests || [] // Добавляем массив ID заявок пользователя
      };

    }



  },

  async getUserRequests(userEmail) {
    const linkPost = `requests?email=${userEmail}`;

    const data = await apiClient.get(linkPost);

    return data.data || [];

  },

  filterRequests(requests, minage, period) {
    return requests.filter((item) => {
      const status = item.currentStatus.name;
      return status === 'approved' ||
             status === 'need-additional-check' ||
             status === 'invite-sent' ||
             status === 'invite-accepted' ||
             status === 'invite-declined';
    }).
    map(item => {
      const ageFromYear = item.youngerGroup ? getFullYear(item.ageFromMs, period) - 1 : getFullYear(item.ageFromMs, period);
      
      switch (minage) {
        case 1.5:
          // Для min_age = 1.5 сохраняем точное значение возраста
          if (ageFromYear >= 1.5 && ageFromYear < 2) {
            item['ageLimitFrom'] = 1.5; // Сохраняем как 1.5 для корректной группировки
          } else {
            item['ageLimitFrom'] = parseInt(ageFromYear);
          }
          break;
        default:
          item['ageLimitFrom'] = parseInt(ageFromYear);
          break;
      }
      
      item['ageLimitTo'] = item['ageLimitFrom'] + 1;
      item['periodFrom'] = parseInt(period);
      item['periodTo'] = period + 1;

      return item;
    });
  },

  groupRequestsByAge(requests) {
    const groups = {
      '2-3': [],
      '4-6': []
    };

    requests.forEach(request => {
      const ageFrom = request.ageLimitFrom || 0;
      
      if (ageFrom >= 2 && ageFrom < 4) {
        groups['2-3'].push(request);
      } else if (ageFrom >= 4 && ageFrom <= 6) {
        groups['4-6'].push(request);
      }
    });

    // Сортировка по queueNumber в каждой группе
    Object.keys(groups).forEach(groupId => {
      groups[groupId].sort((a, b) => {
        const queueA = a.queueNumber || Number.MAX_SAFE_INTEGER;
        const queueB = b.queueNumber || Number.MAX_SAFE_INTEGER;
        return queueB - queueA; // Чем меньше queueNumber, тем выше в списке
      });
    });

    return groups;
  },

  transformRequestsData(requests, myRequestsIds = []) {
    return requests.map(request => {
      // Определяем дату подачи заявки
      let submittedDate;
      let isRepeated = false;
      
      // Проверяем наличие firstDate и сравниваем с createdAt
      if (request.firstDate) {
        const firstDate = new Date(request.firstDate);
        const createdAt = new Date(request.createdAt);
        
        // Если firstDate существует и раньше createdAt, используем firstDate
        if ((firstDate.getTime() + (24*60*60*1000)) < createdAt.getTime()) {
          submittedDate = this.formatDate(request.firstDate);
          isRepeated = true;
        } else {
          submittedDate = this.formatDate(request.createdAt);
        }
      } else {
        submittedDate = this.formatDate(request.createdAt);
      }

      // Получаем базовую дополнительную информацию
      let additionalInfo = this.getAdditionalInfo(request);
      
      // Добавляем "повторна" если заявка повторная
      if (isRepeated) {
        additionalInfo = additionalInfo !== '—' 
          ? `повторна, ${additionalInfo}`
          : 'повторна';
      }

      // Проверяем, является ли заявка заявкой текущего пользователя
      const isMyRequest = myRequestsIds.includes(request._id);

      return {
        id: request._id, // Добавляем ID заявки
        name: request.child.firstName,
        cert: request.child.birthCertificate.number,
        submitted: submittedDate,
        sendFrom: request.preferDateFrom ? this.formatDate(request.preferDateFrom) : this.formatDate(request.createdAt),
        status: this.mapStatus(request.currentStatus.name),
        additional: additionalInfo,
        isRepeated: isRepeated,
        queueNumber: request.queueNumber || Number.MAX_SAFE_INTEGER,
        isMyRequest: isMyRequest // Добавляем флаг принадлежности пользователю
      };
    });
  },

  formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    return `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`;
  },

  mapStatus(apiStatus) {
    const statusMap = {
      'approved': 'accepted',
      'invite-accepted': 'accepted',
      'need-additional-check': 'docs',
      'invite-sent': 'selection',
      'invite-declined': 'deleted'
    };
    
    return statusMap[apiStatus] || 'selection';
  },

  getAdditionalInfo(request) {
    const parts = [];
    
    if (request.indicators && request.indicators.childBenefitsSelected) {
      const benefitVerified = request.indicators.childBenefitsVerified;
      parts.push(`Пільга: ${benefitVerified ? 'Діти військовослужбовців' : 'територія обслуговування'}`);
    }
    
    if (request.specialization && 
        request.specialization.specializationId && 
        request.specialization.medicalProtocol //&& 
        //request.specialization.medicalProtocolDate
        ) {
      parts.push('ІРЦ');
    }
    
    if (request.neededPlaceDescription && request.neededPlaceDescription.notWithoutFullDay) {
      parts.push('Запрошення в цей ДНЗ тільки по...');
    }
    
    if (request.neededPlaceDescription && request.neededPlaceDescription.inclusive) {
      parts.push('інклюзивне');
    }
    
    if (request.languageTraining === 'ir') {
      parts.push('Міжнародний договір');
    }
    
    return parts.length > 0 ? parts.join(', ') : '—';
  }
};

export { zdoRequestsApi };